import React from "react";
import ashleyUpdatesVideo from "../assets/mission-control/ashleyupdates.mp4";
import ringPng from "../assets/mission-control/ring.png";
import { isAshleyLongPressLaunchGuardActive } from "../helpers/ashleyInterfaceLauncher";
import { useAshleyInterface } from "./AshleyInterfaceProvider";
import { useHardwareBackHandler } from "../navigation/HardwareBackContext";
import { ASHLEY_PHASE } from "./ashleyInterfaceTypes";
import "./AshleyVoiceOverlay.css";

export function AshleyVoiceOverlay() {
  const { phase, statusMessage, closeAshleyInterface, isActive, speechPlaybackConfirmed } =
    useAshleyInterface();

  useHardwareBackHandler(() => {
    if (!isActive) {
      return false;
    }

    closeAshleyInterface();
    return true;
  }, isActive);

  if (!isActive) {
    return null;
  }

  const isListening = phase === ASHLEY_PHASE.LISTENING;
  const isSpeakingPhase = phase === ASHLEY_PHASE.SPEAKING;
  const showSpeakingLabel = isSpeakingPhase && speechPlaybackConfirmed;
  const pulseRing = isListening || isSpeakingPhase;

  const statusLabel = isListening
    ? "Listening"
    : showSpeakingLabel
      ? "Speaking"
      : "Ashley";

  const handleBackdropDismiss = () => {
    if (isAshleyLongPressLaunchGuardActive()) {
      return;
    }

    closeAshleyInterface();
  };

  return (
    <div className="ashley-voice-overlay" onClick={handleBackdropDismiss}>
      <div
        className="ashley-voice-overlay__content guide-ashley-listening-panel"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="guide-ashley-listening-figure" aria-hidden="true">
          <video
            autoPlay
            playsInline
            controls={false}
            muted
            loop
            className="ashley-voice-overlay__video"
          >
            <source src={ashleyUpdatesVideo} type="video/mp4" />
          </video>

          <img
            src={ringPng}
            alt=""
            aria-hidden="true"
            className={`ashley-voice-overlay__ring${
              pulseRing ? " ashley-voice-overlay__ring--listening" : ""
            }`}
          />
        </div>

        <div className="ashley-voice-overlay__status" aria-live="polite">
          <p className="ashley-voice-overlay__status-label">
            {statusLabel}
          </p>
          <p className="ashley-voice-overlay__status-message">{statusMessage}</p>
        </div>

        <button
          type="button"
          className="ashley-voice-overlay__dismiss"
          onClick={closeAshleyInterface}
        >
          Close
        </button>
      </div>
    </div>
  );
}
